import urls from './urls.json';

export const getUrls = (service, action) => (service ? urls[service][action] || urls[service] : urls);
